import API_CONSTANT from 'constants/apiConstant';
import { put, takeEvery } from 'redux-saga/effects';
import { triggerFetchCardDetailsApiCall, triggerOrderCardAddressDetailsApiCallSuccess } from 'redux/actions';
import { TRIGGER_ORDER_CARD_ADDRESS_DETAILS_API } from 'redux/actionTypes';
import { apiCall } from 'services';
import { ChangeHistory } from 'utils';

function* triggerOrderCardAddressDetailsApiCall(actions) {
	const { data, callback } = actions;
	const api = yield apiCall({
		urlType: API_CONSTANT.URL_TYPE.CARD,
		url: API_CONSTANT.URL.ORDER_CARD_ADDRESS_DETAILS,
		method: 'POST',
		data,
	});
	if (api && api.data.success) {
		const apiData = api.data;
		callback && callback(apiData);
		yield put(triggerOrderCardAddressDetailsApiCallSuccess(apiData));
		yield put(triggerFetchCardDetailsApiCall());
		ChangeHistory('push', '/order-card/delivery-status');
	}
}

export default function* triggerOrderCardAddressDetailsApiCallSaga() {
	yield takeEvery(TRIGGER_ORDER_CARD_ADDRESS_DETAILS_API, triggerOrderCardAddressDetailsApiCall);
}
